import { Card, CardContent } from 'easyship-components';
import { FormattedMessage } from 'react-intl';

import WarningSVG from '@/svg/Warning.svg';

interface ErrorPageProps {
  error?: string | Error;
  errorMessageId?: string;
  resetErrorBoundary?: () => void;
}

export const ErrorPage = ({ error, errorMessageId }: ErrorPageProps) => {
  const renderErrorMessage = () => {
    if (errorMessageId) {
      return <FormattedMessage id={errorMessageId} />;
    }

    if (typeof error === 'string' && error) {
      return error;
    }

    if (error instanceof Error && error.message) {
      return error.message;
    }

    return <FormattedMessage id="errors.unexpected" />;
  };

  return (
    <div className="w-full max-w-[600px] xl:w-[600px] mx-auto mt-3 sm:mt-5 px-4 sm:px-0 flex flex-col items-center gap-5">
      <Card className="shadow w-full">
        <CardContent className="py-8 px-0">
          <div className="flex flex-col items-center gap-3">
            <div className="flex items-center justify-center size-[60px]">
              <img
                src={WarningSVG}
                alt=""
                className="size-full"
                aria-hidden="true"
              />
            </div>
            <h1 className="font-normal text-xl leading-[150%] text-ink-900 m-0">
              <FormattedMessage id="global.sorry" />
            </h1>
            <p className="font-normal text-base leading-5 text-ink-500 text-center m-0 px-5">
              {renderErrorMessage()}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
